import { concat, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';

import { task, timeout } from 'ember-concurrency';
import { t } from 'ember-intl';
import { consume } from 'ember-provide-consume-context';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class RecordExplorerToolbarSearchComponent extends Component {
  @consume('window') isWindowCompact;

  // Getter and setter
  get searchId() {
    return `search-${guidFor(this)}`;
  }

  // Functions
  updateSearch = (event) => {
    this.throtteldSearch.perform(event.target.value);
  };

  resetSearch = () => {
    this.throtteldSearch.perform('');
  };

  // Tasks
  throtteldSearch = task({ restartable: true }, async (value) => {
    await timeout(400);

    this.args.onSearch(value);
  });

  // Template
  <template>
    <div class={{bem (hash is-compact=this.isWindowCompact)}} ...attributes>
      <label class={{bem 'label'}} for={{this.searchId}}>
        {{t 'record_explorer.toolbar.search.label'}}
      </label>

      <div class={{bem 'field'}}>
        <div class={{bem 'icon'}}>
          {{svgJar 'search' class='u-icon'}}
        </div>

        <input
          class={{bem 'input'}}
          id={{this.searchId}}
          placeholder={{t
            'record_explorer.toolbar.search.placeholder'
            modelPlural=(t (concat 'models.plurals.' @recordType))
          }}
          type='search'
          value={{@searchString}}
          {{on 'input' this.updateSearch}}
        />

        {{#if @searchString}}
          <button
            class={{bem 'reset'}}
            type='button'
            {{on 'click' this.resetSearch}}
          >
            {{t 'record_explorer.toolbar.search.reset'}}
          </button>
        {{/if}}
      </div>
    </div>
  </template>
}
